import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-department.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.department',
    description: 'Chart view of change impacts by department',
    name: 'Change Impacts by Department',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
